import { render, staticRenderFns } from "./permissions-modal.vue?vue&type=template&id=757e727d&"
import script from "./permissions-modal.vue?vue&type=script&lang=js&"
export * from "./permissions-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports